import styled, { css, StyledComponent } from 'styled-components';

export const CommonCellRendererWrapper: StyledComponent<'div', any> = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #494949;
  white-space: pre-wrap;
  word-break: break-word;
  padding: 12px 0;
  align-self: self-start;
`;

export const NameCellRendererWrapper: StyledComponent<'div', any> = styled.div`
  display: flex;
  align-items: center;
  align-self: self-start;
  gap: 10px;
  width: 100%;
  padding: 12px 0;

  font-size: 14px;
  font-weight: 300;
  line-height: 20px;
  color: #0046ff;
`;

export const NameTextContainer: StyledComponent<
  'div',
  any,
  { showDraft?: boolean; disabledCell?: boolean }
> = styled.div<{ showDraft?: boolean; disabledCell?: boolean }>`
  display: flex;
  gap: 4px;

  white-space: pre-wrap;
  word-break: break-word;
  letter-spacing: -0.01em;

  cursor: pointer;

  ${({ disabledCell }) => {
    if (disabledCell) {
      return css`
        color: rgba(0, 0, 0, 0.88);
        cursor: default;
      `;
    }
    return;
  }}

  ${({ showDraft }) => {
    if (showDraft) {
      return css`
        &::before {
          content: '└';
          font-family: 'Nanum Gothic', sans-serif;
          line-height: 20px;
          color: #494949;
          display: flex;
          width: 20px;
          padding: 2px;
          justify-content: center;
        }
      `;
    }
    return;
  }}
`;

export const ListCellRendererWrapper: StyledComponent<'div', any> = styled.div`
  display: flex;
  flex-direction: column;
  align-self: self-start;
  width: 100%;
  padding: 12px 0;

  color: #494949;
`;

export const ListItem: StyledComponent<'div', any> = styled.div`
  display: flex;
  width: 100%;

  line-height: 20px;
  letter-spacing: -0.14px;

  &::before {
    content: '';
    display: inline-block;
    width: 5px;
    height: 5px;
    border-radius: 100%;
    margin-right: 8px;
    margin-top: 8px;
    flex-shrink: 0;

    background-color: #494949;
  }
`;

export const ListItemText: StyledComponent<'span', any> = styled.span`
  display: inline-block;
  white-space: pre-wrap;
  word-break: break-word;
`;

export const ActionsCellRendererWrapper: StyledComponent<'div', any> = styled.div`
  display: flex;
  align-items: center;
  align-self: self-start;
  gap: 5px;
  padding: 12px 0;
  flex-wrap: wrap;
`;
